import React, { ChangeEvent } from 'react';
import { observer } from 'mobx-react-lite';
import { Badge } from '@JohnLewisPartnership/jl-design-system/dist/components/badge/Badge';
import Checkbox from '@JohnLewisPartnership/jl-design-system/dist/components/checkbox/Checkbox';
import { Message } from '@JohnLewisPartnership/jl-design-system/dist/components/message/Message';
import styles from './WishListSelector.module.scss';
import WishListsStore from '../../../stores/WishListsStore';
import { ReactComponent as WishlistPlaceholder } from '../../../assets/icons/wishlist-placeholder.svg';
import { WISHLIST_URL } from '../../../helpers/redirect/constants';

interface WishListSelectorProps {
    store: WishListsStore;
}

function createImageUrl(wishList: ProductWishList): string {
    const totalProducts = wishList.products.length;
    const lastProductIndex = totalProducts - 1;
    if (wishList.image && wishList.image.trim() !== '') return `${wishList.image}?wid=411&hei=548`;
    else return `//media.johnlewiscontent.com/i/JohnLewis/${wishList.products[lastProductIndex].skuId}?wid=411&hei=548`;
}

export const WishListSelector: React.FC<WishListSelectorProps> = observer(({ store }) => {
    return (
        <>
            <div className={styles.wishListsContainer} data-testid="wishlists-list">
                {store.wishLists &&
                    store.wishLists.map((wishList) => {
                        return (
                            <div key={wishList.id} className={styles.wishListWithError}>
                                <div key={wishList.id} className={styles.wishListRow}>
                                    <div className={styles.wishListImage}>
                                        {wishList.products.length ? (
                                            <img src={createImageUrl(wishList)} alt={wishList.name} />
                                        ) : (
                                            <WishlistPlaceholder />
                                        )}
                                    </div>
                                    <div className={styles.wishListDetails}>
                                        <div className={styles.wishListName}>{wishList.name}</div>
                                        <div>
                                            {wishList.products.length}{' '}
                                            {wishList.products.length > 1 ? 'products' : 'product'}
                                        </div>
                                    </div>
                                    <div className={styles.wishListRight}>
                                        <Badge
                                            className={styles.wishListBadge}
                                            label={wishList.shared ? 'Shared' : 'Private'}
                                            badgeType={wishList.shared ? '--success' : '--infomation'}
                                        />
                                        <Checkbox
                                            data-testid={wishList.id}
                                            className={styles.wishListCheckbox}
                                            id={`icon-${wishList.id}`}
                                            key={wishList.id}
                                            name={wishList.id}
                                            label="&nbsp;"
                                            disabled={wishList.isFull}
                                            onChange={(e: ChangeEvent<HTMLInputElement>): void =>
                                                store.handleWishListChange(wishList.id, e.target.checked)
                                            }
                                            checked={store.selectedWishListIds.indexOf(wishList.id) !== -1}
                                            isControlled={false}
                                        />
                                    </div>
                                </div>
                                {wishList.isFull && (
                                    <div className={styles.errorMessageContainer}>
                                        <Message
                                            type="error"
                                            body="Please select another list or delete items"
                                            title="Maximum 200 items reached in this wish list"
                                            buttonText="View list"
                                            buttonProps={{
                                                href: `${WISHLIST_URL}/${wishList.id}`,
                                                tag: 'a',
                                                rel: 'none',
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        );
                    })}
            </div>
            <div className={styles.footer}>
                {store.hasError && (
                    <Message type="error" body={store.errorMessage} title="" className={styles.errorMessage} />
                )}
            </div>
        </>
    );
});
